(() => {
  if (customElements.get('belyr-cart-carousel')) return;

  class BelyrCartCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.track = this.querySelector('[data-belyr-cart-track]');
      this.previous = this.querySelector('[data-belyr-cart-prev]');
      this.next = this.querySelector('[data-belyr-cart-next]');
      this.progress = this.querySelector('[data-belyr-cart-progress]');

      if (!this.track || !this.previous || !this.next || !this.progress) return;

      this.dataset.ready = 'true';
      this.previous.addEventListener('click', () => this.scroll(-1));
      this.next.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.update()), { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.scroll(-1);
        if (event.key === 'ArrowRight') this.scroll(1);
      });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
      }

      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    getStep() {
      const card = this.track.querySelector('[data-belyr-cart-card]');
      if (!card) return this.track.clientWidth;

      const styles = getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scroll(direction) {
      this.track.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
    }

    update() {
      const maximum = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      const position = Math.min(Math.max(this.track.scrollLeft, 0), maximum);
      const visibleRatio = Math.min(this.track.clientWidth / Math.max(this.track.scrollWidth, 1), 1);
      const travelRatio = maximum > 0 ? position / maximum : 0;

      this.previous.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
      this.progress.style.transform = `translateX(${travelRatio * (1 - visibleRatio) * 100}%) scaleX(${visibleRatio})`;
    }
  }

  customElements.define('belyr-cart-carousel', BelyrCartCarousel);
})();
